import { useQuery } from "@tanstack/react-query";
import { X } from "lucide-react";
import type { Dispatch, SetStateAction } from "react";
import { Link } from "react-router";
import HubertLogo from "../../assets/images/hubert-logo.png";
import { fetchViewerProfileQuery } from "../../behavior/api/viewer";
import { PageRoute } from "../../constants";
import { HorizontalLine, Image } from "../elements";
import LanguageSelector from "./LanguageSelector";
import Nav from "./Nav";
import UserDropdown from "./UserDropdown";

interface MobileNavExpandedProps {
    isMobile: boolean;
    setNavbarExpanded: Dispatch<SetStateAction<boolean>>;
}

const MobileNavExpanded = ({ isMobile, setNavbarExpanded }: MobileNavExpandedProps) => {
    const { data: viewer, isLoading: loading } = useQuery({
        queryKey: ["viewer", "profile"],
        queryFn: fetchViewerProfileQuery(),
    });

    return (
        <div className="mobile-nav-expanded-wrapper">
            <div className="head-section">
                <Link to={PageRoute.DASHBOARD}>
                    <Image className="hubert-logo" src={HubertLogo} alt="hubert-logo" />
                </Link>
                <X className="close-icon" onClick={() => setNavbarExpanded((prevState) => !prevState)} />
            </div>
            <Nav isMobile={isMobile} />
            <HorizontalLine weight="semi-dark" />
            <LanguageSelector isMobile={isMobile} language={viewer?.language} />
            <HorizontalLine weight="semi-dark" />
            <UserDropdown isMobile={isMobile} viewer={viewer} loading={loading} />
        </div>
    );
};

export default MobileNavExpanded;
